import withJsonLd from './with-json-ld';
export { JsonLd } from './JsonLd';
export default withJsonLd;